<template>
  <div>
    <div class="controller-wrapper">
      <slot name="openButton">
        <el-button
          type="primary"
          class="m-r-10"
          size="mini"
          plain
          @click="openPop"
        >
          <i class="el-icon-plus m-r-2"></i>
          添加
        </el-button>
      </slot>

      <slot name="tagShow">
        <el-tag
          v-for="(item, index) in selectedList"
          :key="item.companyId"
          effect="plain"
          type="info"
          closable
          size="medium"
          class="m-t-10 m-r-10"
          @close="closeTag(index)"
        >
          {{ item.companyName }}
        </el-tag>
      </slot>
    </div>

    <select-supplier-drawer
      :visible.sync="visible"
      :selected="selectedList"
      :disabled-array="normalizeDisabledList"
      :is-wl="isWl"
      @confirmed="handleDrawerConfirm"
    />
  </div>
</template>

<script>
import SelectSupplierDrawer from '@/components/common/SelectSupplierDrawer/SelectSupplierDrawer'
import { isFunction } from 'element-ui/src/utils/types'
import { cloneDeep } from 'lodash'

export default {
  name: 'SelectSupplierController',

  components: {
    SelectSupplierDrawer
  },

  model: {
    prop: 'selected',
    event: 'change'
  },

  props: {
    selected: {
      type: Array,
      default: () => []
    },

    normalizeIn: {
      type: Function,
      default: list => list
    },

    normalizeOut: {
      type: Function,
      default: list => list
    },

    disabledArray: {
      type: Array,
      default: () => []
    },

    // 是否是五菱
    isWl: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      visible: false,
      selectedList: []
    }
  },

  computed: {
    normalizeDisabledList() {
      if (isFunction(this.normalizeIn)) {
        return this.normalizeIn(this.disabledArray)
      } else {
        return this.disabledArray
      }
    }
  },

  watch: {
    selected: {
      handler: function(value) {
        this.selectedList = cloneDeep(this.normalizeIn(value))
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    openPop() {
      this.visible = true
    },

    closeTag(index) {
      this.selectedList.splice(index, 1)
      if (isFunction(this.normalizeOut)) {
        this.$emit('change', this.normalizeOut(this.selectedList))
      } else {
        this.$emit('change', this.selectedList)
      }
    },

    handleDrawerConfirm(list) {
      this.selectedList = []
      this.selectedList = cloneDeep(list)
      if (isFunction(this.normalizeOut)) {
        this.$emit('change', this.normalizeOut(list))
      } else {
        this.$emit('change', list)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
